// import { PlanFragment } from '../plan'
// import ProductFragment from '../product/ProductFragment'

// export default `
//   fragment UnstableDataFragment on UnstableData {
//     ... on UnstableData__Data {
//       id
//       context
//       data
//       status
//       createdAt
//       updatedAt
//     }
//     ... on UnstableDataOnboarding {
//       id
//       context
//       data {
//         name
//         coupon
//         pets
//         pet
//         plan {
//           ...PlanFragment
//         }
//         recommendedProduct {
//           ...ProductFragment
//         }
//         suggestedProducts {
//           ...ProductFragment
//         }
//       }
//     }
//   }
//   ${PlanFragment}
//   ${ProductFragment}
// `

export default `
  fragment UnstableDataFragment on UnstableData {
    id
    context
    data
    status
    createdAt
    updatedAt 
  }
`
